import { API_ORIGIN } from 'constants/api';

/**
 * Build the document download URL.
 *
 * @method buildDocumentDownloadURL
 * @param  {string}                 token The user's token
 * @return {string}                       The document download URL
 */
export function buildDocumentDownloadURL(token) {
    // If token is not present, return an empty string.
    if (!token) {
        return '';
    }
    // Build the document download URL.
    return `${API_ORIGIN}/v1/sign-documents/token/${token}/download`;
}
